export interface MhrRating {
    rating: number;
    url: string;
}

/**
 * MyHockeyRankings from the 2024-25 Squirt Major season.
 * Used for pre-season tournament predictions.
 */
export const MHR_RATINGS_2024_SQ_MAJOR: Record<string, MhrRating> = {
  "'14 Chicago Jets": { rating: 86.6, url: 'https://myhockeyrankings.com/team_info.php?y=2024&t=2745' },
  "OJG": { rating: 85.9, url: 'https://myhockeyrankings.com/team-info?y=2024&t=34681' },
  "Fox Motors": { rating: 82.6, url: 'https://myhockeyrankings.com/team_info.php?y=2024&t=2081' },
  "GRAHA Griffins PWA 11U 2014": { rating: 86.4, url: 'https://myhockeyrankings.com/team_info.php?y=2024&t=29527' },
  "Hartland Hockey Club Black": { rating: 93.4, url: 'https://myhockeyrankings.com/team-info?y=2024&t=34039' },
  "2014 Cyclones": { rating: 87.4, url: 'https://myhockeyrankings.com/team-info?y=2024&t=12992' },
  "Chicago Blues": { rating: 89.0, url: 'https://myhockeyrankings.com/team-info?y=2024&t=2741' },
  "Sabres": { rating: 84.8, url: 'https://myhockeyrankings.com/team-info?y=2024&t=2008' },
};

/**
 * MyHockeyRankings for the 2025-26 Pee-Wee Minor season.
 */
export const MHR_RATINGS_2025_PW_MINOR: Record<string, MhrRating> = {
  "'14 Chicago Jets": { rating: 83.21, url: 'https://myhockeyrankings.com/team_info.php?y=2025&t=15140' },
  "Buffalo Regals (Rainey)": { rating: 83.76, url: 'https://myhockeyrankings.com/team_info.php?y=2025&t=1140' },
  "Pittsburgh Vengeance": { rating: 83.59, url: 'https://myhockeyrankings.com/team_info.php?y=2025&t=26031' },
  "OJG": { rating: 83.17, url: 'https://myhockeyrankings.com/team_info.php?y=2025&t=34680' },
  "Sylvania Northstars": { rating: 82.43, url: 'https://myhockeyrankings.com/team_info.php?y=2025&t=2289' },
  "GRAHA Griffins PWA 11U 2014": { rating: 83.95, url: 'https://myhockeyrankings.com/team_info.php?y=2025&t=34058' },
  "Houston Junior Aeros 12U A": { rating: 83.22, url: 'https://myhockeyrankings.com/team_info.php?y=2025&t=26248' },
  "Metro Jets": { rating: 80.82, url: 'https://myhockeyrankings.com/team_info.php?y=2025&t=2550' },
  "Midwest Blackbirds 12UAA": { rating: 81.67, url: 'https://myhockeyrankings.com/team_info.php?y=2025&t=18854' },
  "London Junior Knights Green AA": { rating: 84.68, url: 'https://myhockeyrankings.com/team_info.php?y=2025&t=14327' },
};

/**
 * MyHockeyRankings for the 2026-27 Pee-Wee Major (12U AA) season.
 * Covers CCM World Invite 2026 teams across all 8 pools and seasonal opponents.
 */
export const MHR_RATINGS_2026_PW_MAJOR: Record<string, MhrRating> = {
  // --- Pool E (Jets Pool) ---
  "'14 Chicago Jets": { rating: 89.25, url: 'https://myhockeyrankings.com/team-info?y=2026&t=2564' },
  "Chicago Jets": { rating: 89.25, url: 'https://myhockeyrankings.com/team-info?y=2026&t=2564' },
  "Chicago Jets (CSDHL) 12U AA": { rating: 89.25, url: 'https://myhockeyrankings.com/team-info?y=2026&t=2564' },

  "California Wave": { rating: 85.86, url: 'https://myhockeyrankings.com/team-info?y=2026&t=30614' },
  "California Wave 12AA": { rating: 85.86, url: 'https://myhockeyrankings.com/team-info?y=2026&t=30614' },
  "California Wave 12U AA": { rating: 85.86, url: 'https://myhockeyrankings.com/team-info?y=2026&t=30614' },

  "Traverse City North Stars": { rating: 88.69, url: 'https://myhockeyrankings.com/team-info?y=2026&t=2897' },
  "Traverse City North Stars 12U AA": { rating: 88.69, url: 'https://myhockeyrankings.com/team-info?y=2026&t=2897' },

  "Winnetka Warriors": { rating: 86.93, url: 'https://myhockeyrankings.com/team-info?y=2026&t=2457' },
  "Winnetka Warriors 2014 CS": { rating: 86.93, url: 'https://myhockeyrankings.com/team-info?y=2026&t=2457' },
  "Winnetka Warriors (CSDHL) 12U AA": { rating: 86.93, url: 'https://myhockeyrankings.com/team-info?y=2026&t=2457' },

  // --- Pool A ---
  "Northern Express": { rating: 89.93, url: 'https://myhockeyrankings.com/team-info?y=2026&t=2024' },
  "Northern Express (CSDHL) 12U AA": { rating: 89.93, url: 'https://myhockeyrankings.com/team-info?y=2026&t=2024' },

  "Omaha Jr Mavericks Black": { rating: 87.30, url: 'https://myhockeyrankings.com/team-info?y=2026&t=19130' },
  "Omaha Jr Mavericks (Black) 12U AA": { rating: 87.30, url: 'https://myhockeyrankings.com/team-info?y=2026&t=19130' },
  "Omaha Jr Mavericks": { rating: 87.30, url: 'https://myhockeyrankings.com/team-info?y=2026&t=19130' },

  "Compuware": { rating: 88.58, url: 'https://myhockeyrankings.com/team-info?y=2026&t=2358' },
  "Compuware 12U AA": { rating: 88.58, url: 'https://myhockeyrankings.com/team-info?y=2026&t=2358' },

  "Tri-State Spartans": { rating: 86.51, url: 'https://myhockeyrankings.com/team-info?y=2026&t=19720' },
  "Tri-State Spartans 12U AAA": { rating: 86.51, url: 'https://myhockeyrankings.com/team-info?y=2026&t=19720' },

  // --- Pool B ---
  "Naperville Sabres": { rating: 87.25, url: 'https://myhockeyrankings.com/team-info?y=2026&t=32497' },
  "Naperville Sabres (CSDHL) 12U AA": { rating: 87.25, url: 'https://myhockeyrankings.com/team-info?y=2026&t=32497' },

  "Marquette Junior Wildcats": { rating: 87.20, url: 'https://myhockeyrankings.com/team-info?y=2026&t=3208' },
  "Marquette Junior Wildcats (Superior) 12U AA": { rating: 87.20, url: 'https://myhockeyrankings.com/team-info?y=2026&t=3208' },

  "Fremont Warbirds": { rating: 89.90, url: 'https://myhockeyrankings.com/team-info?y=2026&t=25638' },
  "Fremont Warbirds 12U A": { rating: 89.90, url: 'https://myhockeyrankings.com/team-info?y=2026&t=25638' },

  "St. Louis Knights": { rating: 88.18, url: 'https://myhockeyrankings.com/team-info?y=2026&t=2042' },
  "St Louis Knights": { rating: 88.18, url: 'https://myhockeyrankings.com/team-info?y=2026&t=2042' },
  "St Louis Knights 12U AA": { rating: 88.18, url: 'https://myhockeyrankings.com/team-info?y=2026&t=2042' },

  // --- Pool C ---
  "Fort Wayne Force Blue": { rating: 88.29, url: 'https://myhockeyrankings.com/team-info?y=2026&t=2460' },
  "Fort Wayne Force (Blue) 12U AA": { rating: 88.29, url: 'https://myhockeyrankings.com/team-info?y=2026&t=2460' },
  "Fort Wayne Force": { rating: 88.29, url: 'https://myhockeyrankings.com/team-info?y=2026&t=2460' },

  "Chicago Hawks": { rating: 87.21, url: 'https://myhockeyrankings.com/team-info?y=2026&t=2755' },
  "Chicago Hawks (CSDHL) 12U AA": { rating: 87.21, url: 'https://myhockeyrankings.com/team-info?y=2026&t=2755' },

  "GRAHA Griffins": { rating: 88.48, url: 'https://myhockeyrankings.com/team-info?y=2026&t=2641' },
  "Grand Rapids Griffins": { rating: 88.48, url: 'https://myhockeyrankings.com/team-info?y=2026&t=2641' },
  "Grand Rapids Griffins 12U AA": { rating: 88.48, url: 'https://myhockeyrankings.com/team-info?y=2026&t=2641' },

  "Texas Jr Brahmas": { rating: 87.58, url: 'https://myhockeyrankings.com/team-info?y=2026&t=19762' },
  "Texas Jr Brahmas 12U AA": { rating: 87.58, url: 'https://myhockeyrankings.com/team-info?y=2026&t=19762' },

  // --- Pool D ---
  "Music City Marauders": { rating: 88.90, url: 'https://myhockeyrankings.com/team-info?y=2026&t=34346' },
  "Music City Marauders (French) 12U AA": { rating: 88.90, url: 'https://myhockeyrankings.com/team-info?y=2026&t=34346' },

  "St Louis Eagles": { rating: 88.01, url: 'https://myhockeyrankings.com/team-info?y=2026&t=27570' },
  "St. Louis Eagles": { rating: 88.01, url: 'https://myhockeyrankings.com/team-info?y=2026&t=27570' },
  "St Louis Eagles 12U AA": { rating: 88.01, url: 'https://myhockeyrankings.com/team-info?y=2026&t=27570' },

  "Ann Arbor Bombers Orange": { rating: 86.08, url: 'https://myhockeyrankings.com/team-info?y=2026&t=34916' },
  "Ann Arbor Bombers (Orange) 12U AA": { rating: 86.08, url: 'https://myhockeyrankings.com/team-info?y=2026&t=34916' },
  "Ann Arbor Bombers": { rating: 86.08, url: 'https://myhockeyrankings.com/team-info?y=2026&t=34916' },

  "Wilmette Jr Trevians": { rating: 89.84, url: 'https://myhockeyrankings.com/team-info?y=2026&t=15151' },
  "Wilmette Jr Trevians (CSDHL) 12U AA": { rating: 89.84, url: 'https://myhockeyrankings.com/team-info?y=2026&t=15151' },

  // --- Pool F ---
  "West Dundee Leafs": { rating: 88.09, url: 'https://myhockeyrankings.com/team-info?y=2026&t=3799' },
  "West Dundee Leafs (CSDHL) 12U AA": { rating: 88.09, url: 'https://myhockeyrankings.com/team-info?y=2026&t=3799' },

  "Lake County Vipers": { rating: 88.75, url: 'https://myhockeyrankings.com/team-info?y=2026&t=14362' },
  "Lake County Vipers (CSDHL) 12U AA": { rating: 88.75, url: 'https://myhockeyrankings.com/team-info?y=2026&t=14362' },

  "LA Jr Kings": { rating: 88.01, url: 'https://myhockeyrankings.com/team-info?y=2026&t=3581' },
  "LA Jr Kings (#1) 12U AA": { rating: 88.01, url: 'https://myhockeyrankings.com/team-info?y=2026&t=3581' },

  "St Louis Sting": { rating: 87.14, url: 'https://myhockeyrankings.com/team-info?y=2026&t=15806' },
  "St. Louis Sting": { rating: 87.14, url: 'https://myhockeyrankings.com/team-info?y=2026&t=15806' },
  "St Louis Sting 12U AA": { rating: 87.14, url: 'https://myhockeyrankings.com/team-info?y=2026&t=15806' },

  // --- Pool G ---
  "Chicago Blues": { rating: 86.70, url: 'https://myhockeyrankings.com/team-info?y=2026&t=2039' },
  "Chicago Blues (CSDHL) 12U AA": { rating: 86.70, url: 'https://myhockeyrankings.com/team-info?y=2026&t=2039' },

  "San Diego Jr Gulls": { rating: 87.54, url: 'https://myhockeyrankings.com/team-info?y=2026&t=34513' },
  "San Diego Jr Gulls 12U AA": { rating: 87.54, url: 'https://myhockeyrankings.com/team-info?y=2026&t=34513' },

  "Orland Park Vikings": { rating: 89.55, url: 'https://myhockeyrankings.com/team-info?y=2026&t=3019' },
  "Orland Park Vikings (CSDHL) 12U AA": { rating: 89.55, url: 'https://myhockeyrankings.com/team-info?y=2026&t=3019' },

  "Las Vegas Storm": { rating: 86.54, url: 'https://myhockeyrankings.com/team-info?y=2026&t=28212' },
  "Las Vegas Storm 12U AA": { rating: 86.54, url: 'https://myhockeyrankings.com/team-info?y=2026&t=28212' },

  // --- Pool H ---
  "Geneva Cyclones": { rating: 89.06, url: 'https://myhockeyrankings.com/team-info?y=2026&t=14581' },
  "Geneva Cyclones (CSDHL) 12U AA": { rating: 89.06, url: 'https://myhockeyrankings.com/team-info?y=2026&t=14581' },
  "2014 Cyclones": { rating: 89.06, url: 'https://myhockeyrankings.com/team-info?y=2026&t=14581' },

  "Highland Park Falcons": { rating: 86.77, url: 'https://myhockeyrankings.com/team-info?y=2026&t=2040' },
  "Highland Park Falcons (CSDHL) 12U AA": { rating: 86.77, url: 'https://myhockeyrankings.com/team-info?y=2026&t=2040' },

  "Foothills Flyers": { rating: 88.02, url: 'https://myhockeyrankings.com/team-info?y=2026&t=26452' },
  "Foothills Flyers 12U AA": { rating: 88.02, url: 'https://myhockeyrankings.com/team-info?y=2026&t=26452' },

  "Arizona Bobcats": { rating: 87.44, url: 'https://myhockeyrankings.com/team-info?y=2026&t=2539' },
  "Arizona Bobcats 12U AA": { rating: 87.44, url: 'https://myhockeyrankings.com/team-info?y=2026&t=2539' },

  // --- Other Opponents (CSDHL / Tournaments) ---
  "Hartland Hockey Club Black": { rating: 91.00, url: 'https://myhockeyrankings.com/team-info?y=2026&t=2280' },
  "Hartland Huskies (Black) 12U AA": { rating: 91.00, url: 'https://myhockeyrankings.com/team-info?y=2026&t=2280' },
  "Fox Motors": { rating: 83.54, url: 'https://myhockeyrankings.com/team-info?y=2026&t=2214' },
  "Fox Motors 12U AA": { rating: 83.54, url: 'https://myhockeyrankings.com/team-info?y=2026&t=2214' },
};

/**
 * Normalizes a team name for fuzzy matching across varying naming formats in tournament brackets.
 */
export function normalizeTeamKey(name: string): string {
    return name
        .toLowerCase()
        .replace(/['’]14\b/g, '')
        .replace(/\b2014\b/g, '')
        .replace(/\b(csdhl|cs|nihl)\b/g, '')
        .replace(/\b(12u|11u|10u)\b/g, '')
        .replace(/\b(12aa|11aa|10aa|12a|11a)\b/g, '')
        .replace(/\b(aaa|aa|a1|a2|a3|a4|a|bb|b)\b/g, '')
        .replace(/\bst\./g, 'st')
        .replace(/[^a-z0-9]/g, '')
        .trim();
}

/**
 * Resolves the appropriate MHR rating for a team, prioritizing:
 * 1. An explicit primary rating table (if passed)
 * 2. 2026 Pee-Wee Major (12U) ratings
 * 3. 2025 Pee-Wee Minor (11U) ratings fallback
 * 4. 2024 Squirt Major (10U) ratings fallback
 */
export function getMhrRating(
    teamName: string,
    primaryRatings?: Record<string, MhrRating>
): MhrRating | undefined {
    if (!teamName) return undefined;
    const trimmed = teamName.trim();

    // 1. Exact match in primary
    if (primaryRatings && primaryRatings[trimmed]) {
        return primaryRatings[trimmed];
    }

    // 2. Exact match in 2026 ratings
    if (MHR_RATINGS_2026_PW_MAJOR[trimmed]) {
        return MHR_RATINGS_2026_PW_MAJOR[trimmed];
    }

    // 3. Normalized matching in primary ratings
    const norm = normalizeTeamKey(trimmed);
    if (primaryRatings) {
        for (const [key, rating] of Object.entries(primaryRatings)) {
            if (normalizeTeamKey(key) === norm) {
                return rating;
            }
        }
    }

    // 4. Normalized matching in 2026 ratings
    for (const [key, rating] of Object.entries(MHR_RATINGS_2026_PW_MAJOR)) {
        if (normalizeTeamKey(key) === norm) {
            return rating;
        }
    }

    // 5. Fallback exact or normalized in 2025 ratings
    if (MHR_RATINGS_2025_PW_MINOR[trimmed]) {
        return MHR_RATINGS_2025_PW_MINOR[trimmed];
    }
    for (const [key, rating] of Object.entries(MHR_RATINGS_2025_PW_MINOR)) {
        if (normalizeTeamKey(key) === norm) {
            return rating;
        }
    }

    // 6. Fallback in 2024 ratings
    if (MHR_RATINGS_2024_SQ_MAJOR[trimmed]) {
        return MHR_RATINGS_2024_SQ_MAJOR[trimmed];
    }
    for (const [key, rating] of Object.entries(MHR_RATINGS_2024_SQ_MAJOR)) {
        if (normalizeTeamKey(key) === norm) {
            return rating;
        }
    }

    return undefined;
}